import Utils from '../utils'

function logout (APIName) {
  const API = Utils._getAPI(APIName)
  return API.logout()
}

export default logout
